import { render, staticRenderFns } from "./EconomyAggregateResult.vue?vue&type=template&id=0e843344&lang=html&"
import script from "./EconomyAggregateResult.vue?vue&type=script&lang=js&"
export * from "./EconomyAggregateResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports